import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./endpointnetworkinfo-widget.html';

        function EndpointNetworkInfo(params) {

            var self = this;
            self.widgetSignals = params.widgetSignals;
            if (self.widgetSignals)
                self.widgetSignals().dataLoaded.dispatch();

        }

        EndpointNetworkInfo.prototype.dispose = function () {
        };

        export default { viewModel: EndpointNetworkInfo, template: templateMarkup };

    
